import { format } from 'date-fns';
import { Card, Page } from '../../components/Page';
import { useDbQuery } from '../../db/hooks';

export function AboutPage() {
  const consent = useDbQuery<{ value: string | null }>("SELECT value FROM settings WHERE id = 'consent' AND deleted_at IS NULL", [], ['settings']);
  const acceptedAt = (() => {
    try {
      const value = consent.data?.[0]?.value;
      return value ? (JSON.parse(value) as { accepted_at: string }).accepted_at : null;
    } catch {
      return null;
    }
  })();

  return (
    <Page title="About & disclaimer" back="/more">
      <Card title="Medical disclaimer">
        <div className="space-y-3 text-sm leading-6">
          <p>
            <strong>RenalFlow is a personal record-keeping tool.</strong> It is not a medical device and does not give medical advice, diagnose
            anything, or recommend doses.
          </p>
          <p>Reference ranges shown with lab results are general. Your lab’s printed range and your care team’s advice always come first.</p>
          <p>
            <strong>In an emergency, call your local emergency number</strong> or contact your dialysis unit straight away.
          </p>
          {acceptedAt ? <p className="text-xs text-clinical-muted">You accepted this on {format(new Date(acceptedAt), 'd MMMM yyyy')}.</p> : null}
        </div>
      </Card>
      <Card title="Your data">
        <p className="text-sm leading-6">
          What you log is saved on this device and synced to your RenalFlow account, encrypted in transit and at rest. It is never sold or
          shared. Read the{' '}
          <a href="https://getrenalflow.com/privacy" target="_blank" rel="noreferrer" className="text-clinical-primary underline">
            privacy policy
          </a>
          .
        </p>
      </Card>
      <Card title="Version">
        <p className="text-sm text-clinical-muted">RenalFlow {__APP_VERSION__}</p>
      </Card>
    </Page>
  );
}
